/* @flow */
import Message from 'entities/Message';
import ChatMessage from 'entities/ChatMessage';
import Group from 'entities/Group';

export default function getChatUuid(
  message: Message | ChatMessage,
  group: ?Group,
  subgroupRole: ?string
): ?string {
  // First, check if this message is in a thread.
  const messageThread = message.get('thread');
  if (messageThread) {
    return messageThread.uuid;
  } else if (group && subgroupRole) {
    const roleThread = group.getThread(subgroupRole);
    if (roleThread) {
      return roleThread.uuid;
    }
  }

  // If the message is not in a thread, use the chat.
  const chat = message.get('chat');
  if (chat) {
    return chat.uuid;
  }

  return null;
}
